import { adminAuthenticatedFetch } from "../../utils/session";

async function json(response) {
  if (!response.ok) {
    const err = new Error(`Request failed: ${response.status}`);
    err.response = response;
    throw err;
  }
  return response.json();
}

async function withErrorJson(response) {
  let data;

  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const err = new Error(data?.error || `Request failed: ${response.status}`);

    Object.assign(err, data); //  attach full API response
    err.status = response.status;

    throw err;
  }

  return data;
}
class AdminService {
  async getCallRecordSubscription() {
    const res = await adminAuthenticatedFetch(
      `/api/callRecordSubscriptionHandler/subscription`,
    );
    return json(res);
  }

  async postCallRecordSubscription(expirationInDays) {
    const res = await adminAuthenticatedFetch(`/api/callRecordSubscriptionHandler/subscription`, {
      method: "POST",
      body: JSON.stringify({ expirationInDays }),
    });
    return json(res);
  }

  async refreshCallRecordSubscription() {
    const res = await adminAuthenticatedFetch(
      `/api/callRecordSubscriptionHandler/refreshSubscription`,
      { method: "POST" },
    );
    return json(res);
  }

  async exchangeSalesforceCode(code) {
    const res = await adminAuthenticatedFetch("/api/salesforce/oauth/callback", {
      method: "POST",
      body: JSON.stringify(code),
    });
    return json(res);
  }

  async postAdminOnboarding() {
    const res = await adminAuthenticatedFetch(`/api/db/tenant/onboard`, {
      method: "POST",
    });
    return json(res);
  }

  async postAdminOnboardingSync(syncCreatedAt) {
    const res = await adminAuthenticatedFetch(`/api/db/tenant/onboard/sync`, {
      method: "POST",
      body: JSON.stringify({ syncCreatedAt }),
    });
    return json(res);
  }

  async postAdminOnboardingClient(clientCreatedAt) {
    const res = await adminAuthenticatedFetch(`/api/db/tenant/onboard/client`, {
      method: "POST",
      body: JSON.stringify({ clientCreatedAt }),
    });
    return json(res);
  }

  async getUserInfo() {
    const res = await adminAuthenticatedFetch(`/api/db/user/info`);
    return json(res);
  }

  async getManageCustomers() {
    const res = await adminAuthenticatedFetch(`/api/admin/getTenantsInfo`);
    return json(res);
  }

  async checkManageCustomers() {
    const res = await adminAuthenticatedFetch(`/api/admin/isAuthorizedManagedCustomer`);
    return json(res);
  }

  async getUsersOfTenant(searchUsersTenantId, params = {}) {
    const {
      page = 1,
      pageSize = 25,
      search,
      sortBy,
      sortOrder,
    } = params;

    // eslint-disable-next-line no-undef
    const queryParams = new URLSearchParams();

    queryParams.append("page", page);
    queryParams.append("pageSize", pageSize);

    if (searchUsersTenantId) {
      queryParams.append("searchUsersTenantId", searchUsersTenantId);
    }

    if (search) {
      queryParams.append("search", search);
    }

    if (sortBy) {
      queryParams.append("sortBy", sortBy);
      if (sortOrder) {
        queryParams.append("sortOrder", sortOrder);
      }
    }

    const baseUrl = searchUsersTenantId
      ? "/api/admin/getUsersOfTenant"
      : "/api/admin/getManageUsersOfTenant";

    const url = `${baseUrl}?${queryParams.toString()}`;

    const res = await adminAuthenticatedFetch(url);
    return withErrorJson(res);
  }

  async getSFOrgsOfTenant(searchTenantId) {
    const res = await adminAuthenticatedFetch(`/api/admin/getSFOrgsOfTenant?searchTenantId=${encodeURIComponent(searchTenantId)}`);
    return withErrorJson(res);
  }

  async deleteMsTeamsUser(msUserId, deleteUserTenantId) {
    const res = await adminAuthenticatedFetch(`/api/admin/deleteMsTeamsUser?msUserId=${encodeURIComponent(msUserId)}&deleteUserTenantId=${encodeURIComponent(deleteUserTenantId)}`, {
      method: "DELETE"
    });
    return json(res);
  }

  async msUserDeactivation(msUserId, deactivateMsUserTenantId) {
    const res = await adminAuthenticatedFetch(deactivateMsUserTenantId ? `/api/admin/msUserDeactivation?msUserId=${encodeURIComponent(msUserId)}&deactivateMsUserTenantId=${encodeURIComponent(deactivateMsUserTenantId)}` : `/api/admin/manageUserMsUserDeactivation?msUserId=${encodeURIComponent(msUserId)}`, {
      method: "POST"
    });
    return json(res);
  }

  async msUserActivation(msUserId, activateMsUserTenantId) {
    const res = await adminAuthenticatedFetch(activateMsUserTenantId ? `/api/admin/msUserActivation?msUserId=${encodeURIComponent(msUserId)}&activateMsUserTenantId=${encodeURIComponent(activateMsUserTenantId)}` : `/api/admin/manageUserMsUserActivation?msUserId=${encodeURIComponent(msUserId)}`, {
      method: "POST"
    });
    return json(res);
  }

  async deleteSFOrg(sfOrgId, deleteSfOrgTenantId) {
    const res = await adminAuthenticatedFetch(`/api/admin/deleteSFOrg?sfOrgId=${encodeURIComponent(sfOrgId)}&deleteSfOrgTenantId=${encodeURIComponent(deleteSfOrgTenantId)}`, {
      method: "DELETE"
    });
    return json(res);
  }

  async getSFConnection() {
    const res = await adminAuthenticatedFetch(`/api/db/salesforce/orgs`);
    return json(res);
  }

  async postSFConnection(orgsInfo) {
    const res = await adminAuthenticatedFetch(`/api/db/salesforce/onboard`, {
      method: "POST",
      body: JSON.stringify(orgsInfo),
    });
    return json(res);
  }

  async deleteSFConnection(sfOrgId) {
    const res = await adminAuthenticatedFetch(`/api/db/salesforce/org/${sfOrgId}`, {
      method: "DELETE",
    });
    return json(res);
  }
  async editACSConnection(acsInfo) {
    const res = await adminAuthenticatedFetch(`/api/keyvault/tenant/config`, {
      method: "POST",
      body: JSON.stringify(acsInfo),
    });
    return json(res);
  }
}

export default new AdminService();
